import { cn } from "@/lib/utils";

interface QueryTableFilteredSortedBadgeDividerProps {
  dividerClassName: string;
  className?: string;
}

export const QueryTableFilteredSortedBadgeDivider = ({
  dividerClassName,
  className,
}: QueryTableFilteredSortedBadgeDividerProps) => (
  <span className={cn("h-4 w-px shrink-0", dividerClassName, className)} />
);
